import React from 'react'

import { 
  Form, 
  Input, 
  Upload,
  InputNumber, 
  Button, 
  Checkbox, 
  Row, 
  Col, 
  Icon 
} from 'antd';

import { API_ENDPOINT } from '../../index'

const PLACEHOLDER_DOMAIN = 'placeholder.com'

class EnterpriseForm extends React.Component {

  state = {
    domainNames: this.props.activeEnterprise.domainNames && this.props.activeEnterprise.domainNames.length > 0  ? this.props.activeEnterprise.domainNames : [PLACEHOLDER_DOMAIN]
  }

  render() {

    
    const { activeEnterprise } = this.props

    const { getFieldDecorator } = this.props.form;

    const { domainNames } = this.state

    return (
      <div>
        <style dangerouslySetInnerHTML={{__html: `
          .enterprise-form .ant-row{
            margin: 0px;
          }

          .enterprise-form .ant-form-item-label{
            line-height: 16px;
          }
        `}}/>
      <Form 
      className="enterprise-form"
      style={{margin: 16}}
      onSubmit={this.handleSubmit}>
        <Form.Item label="Enterprise Name">
          {getFieldDecorator('companyName', {
            initialValue: activeEnterprise.companyName,
            rules: [{ required: true}],
          })(
            <Input
              prefix={<Icon type="team" style={{ color: 'rgba(0,0,0,.25)' }} />}
              placeholder="Company Name"
            />,
          )}
        </Form.Item>
        <Form.Item label="movFreeDelivery">
          {getFieldDecorator('movFreeDelivery', {
            initialValue: activeEnterprise.movFreeDelivery,
            rules: [{ required: true}],
          })(
            <InputNumber
                style={{width: 120}}
                placeholder={200}
                // max={5}
                min={1}  
            />,
          )}
        </Form.Item>
        <Form.Item label="Logo">
          {getFieldDecorator('logoUrl', {
            valuePropName: 'file.response.image.url',
            getValueFromEvent: this.normFile,
          })(
            <Upload.Dragger 
            action={`${API_ENDPOINT}/api/upload/enterprise-image`}
            name='picture'
            accept="image/*"
            withCredentials={true}>
              {this.state.imageUrl?
              <img src={this.state.imageUrl} style={{height: 150}}/>
              :
              <div>
                <p className="ant-upload-drag-icon">
                  <Icon type="inbox" />
                </p>
                <p className="ant-upload-text">Click or drag file to this area to upload</p>
                <p className="ant-upload-hint">Support for a single or bulk upload.</p>
              </div>}
            </Upload.Dragger>,
          )}
        </Form.Item>
        {domainNames.map( (_domainName, index) => (
          <Form.Item label={index == 0 ? "Domain": null}>
            <Row type="flex" gutter={4}>
              <Col span={18}>
              {/* <Button onClick={()=>console.log(domainNames)}>console log</Button>  */}
              {getFieldDecorator(`domain-${index}`, {
                initialValue: _domainName,
                rules: [{ required: index == 0 }],
              })(
                <Input
                  onChange={(e)=>this.handleDomainNameChange(e, index)}
                  style={{width: '100%'}}
                  prefix="@"
                  placeholder="eezee.sg"
                />
              )}
              </Col>
              {index == domainNames.length - 1 && domainNames.length != 1 && <Col span={3}>
                <Button onClick={()=>this.handleRemoveDomainName(index)}>
                  <Icon type="minus"/>
                </Button>
              </Col>}
              {index == domainNames.length - 1 && <Col span={3}>
                <Button onClick={this.handleAddDomainName}>
                  <Icon type="plus"/>
                </Button>
              </Col>}
            </Row>
          </Form.Item>
        ))}
        <Form.Item label="Short Name">
          {getFieldDecorator('shortName', {
            initialValue: activeEnterprise.shortName,
            rules: [{ required: true}],
          })(
            <Input
              placeholder="short form name"
            />,
          )}
        </Form.Item>
        {/* <Form.Item label="Credit Term Days">
          {getFieldDecorator('creditTermDays', {
            initialValue: activeEnterprise.creditTermDays,
            rules: [{ required: true}],
          })(
            <InputNumber
              placeholder={30}
            />,
          )}
        </Form.Item>
        <Form.Item label="Credit Limit">
          {getFieldDecorator('creditLimit', {
            initialValue: activeEnterprise.creditLimit,
            rules: [{ required: true}],
          })(
            <InputNumber
              placeholder={3000}
            />,
          )}
        </Form.Item> */}
        
        <Form.Item>
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </Form.Item>
      </Form>
      </div>
    );
  }

  normFile = e => {

    console.log('Upload event:', e);
    if (Array.isArray(e)) {
      return e;
    }

    if( e.file.response && e.file.response.image ){
      this.setState({
        imageUrl: e.file.response.image.url
      })
    }

    return e && e.file && e.file.response && e.file.response.image.url;

  };

  handleDomainNameChange = (e, index) => {

    const { domainNames } = this.state
    
    this.setState({
      domainNames: [...domainNames.slice(0, index), e.target.value, ...domainNames.slice(index+1)]
    })
  }

  handleRemoveDomainName = (index) => {

    const { domainNames } = this.state
    
    this.setState({
      domainNames: [...domainNames.slice(0, index), ...domainNames.slice(index + 1)]
    })

  }

  handleAddDomainName = () => {

    const { domainNames } = this.state

    this.setState({
      domainNames: [...domainNames, PLACEHOLDER_DOMAIN]
    })

  }

  
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      console.log('values', values)
      if (!err) {

        
        values.domainNames = Object.keys(values).reduce( (acc, curr) => {
          if( curr.split('-')[0] == 'domain' && values[curr].length > 0){
            acc.push( values[curr])
          }

          return acc
        }, [])

        // console.log(values)

        if( this.props.activeEnterprise){

            this.props.editEnterprise({
                enterpriseId: this.props.activeEnterprise._id,
                data: values
            })

        } else {

            this.props.addEnterprise(values)
        }


      }
    });
  };

}

export default Form.create()(EnterpriseForm)


// WEBPACK FOOTER //
// ./src/components/enterprise/form.js